import { request } from '@umijs/max';
import type { ApiResponse, CurrentUser } from './types';

// 发送短信验证码
export async function sendSmsCode(phone: string) {
  return request<ApiResponse>('/api/auth/sms/send', {
    method: 'POST',
    data: { phone },
  });
}

// 短信验证码登录
export async function loginBySms(params: { phone: string; code: string }) {
  return request<ApiResponse<{ token: string; user: CurrentUser }>>('/api/auth/login/sms', {
    method: 'POST',
    data: params,
  });
}

// 密码登录
export async function loginByPassword(params: { username: string; password: string }) {
  return request<ApiResponse<{ token: string; user: CurrentUser }>>('/api/auth/login', {
    method: 'POST',
    data: params,
  });
}

// 获取当前用户信息
export async function getUserInfo() {
  return request<ApiResponse<CurrentUser>>('/api/auth/user/info', {
    method: 'GET',
  });
}

// 退出登录
export async function logout() {
  return request<ApiResponse>('/api/auth/logout', {
    method: 'POST',
  });
}

// 刷新Token
export async function refreshToken() {
  return request<ApiResponse<{ token: string }>>('/api/auth/refresh', {
    method: 'POST',
  });
}

// 飞书登录
export async function loginByFeishu(code: string, redirectUri?: string) {
  return request<ApiResponse<{ token: string; user: CurrentUser }>>('/api/auth/login/feishu', {
    method: 'POST',
    data: { code, redirectUri },
  });
}
